// extracted by mini-css-extract-plugin
export default {"call":"NumberPhone_call__x05F5","call__tel":"NumberPhone_call__tel__NMNnM"};